import {
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  FormHelperText,
  Tooltip,
  makeStyles
} from "@material-ui/core";
import { useFormik } from "formik";
import { useCallback, useEffect } from "react";
import en from "../../../lang/en-us";
import { CustomRadio } from "../../../lib/CustomRadio";
import DatePickerInput from "../../../lib/DatePicker";
import Form, { InputType } from "../../../lib/Formik";
import TextInput from "../../../lib/TextField";
import {
  checkForOnlyAlphabets,
  EIGHTEEN_YEARS_IN_MILLISECONDS,
  isAlphaNumericAddress,
  isAlphaNumeric,
  MAX_LENGTH_FOR_PAN,
  MAX_LENGTH_FOR_NOMINEE_NAME,
  MAX_LENGTH_FOR_GUARDIAN_NAME,
  MAX_LENGTH_FOR_ADDRESS,
  minDateForCalender,
  _minDateForCalender,
} from "../../../utils/constants";
import { getNameIndex } from "../CorrectionFolios/correction-folios-selection";
import { NOMINEEINFO, validationSchemaNominee } from "./update-nominee-edit";
import Image from "../../Image";
import { CheckBoxField } from "../../../lib/CheckBoxField";
import { mobileRegex, emailRegex } from "../transactions/newInvestor";
const { dashboard, common } = en;
const useStyles = makeStyles(() => ({
  customTooltip: {
    fontSize: '16px',
    backgroundColor: '#2f2f2f',
    color: '#fff',
    padding: '10px 14px',
    borderRadius: '8px',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.2)',
  },
}));

function AddNomineeForm(props: any) {
  const { formik } = props;
  const thisYear = new Date().getFullYear();
  const classes = useStyles();
  const resetFieldError = (fieldName: string) => {
    const { [fieldName]: excldeKey, ...rest } = formik.errors;
    formik.setErrors(rest);
  };

  return (
    <>
      <div className="edit-add-nominee">
        <h3>
          {" "}
          <Image src={"/images/family-icon.svg"} alt="icon" />
          {getNameIndex(props.index)} {dashboard.UpdateNominee.nomineeText}
        </h3>
        <a onClick={formik.handleSubmit} className="save-nominee">
          {dashboard.UpdateNominee.save}
        </a>
        {/* <a onClick={() => formik.resetForm()} className="clear-nominee">
                    {dashboard.UpdateNominee.clear}
                </a> */}
        <a
          onClick={() =>
            props.cancelFormSubmission(props.index - 1, formik.values.id)
          }
          className="clear-nominee"
        >
          {dashboard.UpdateNominee.cancel}
        </a>
        <div className="edit-add-nominee-inner">
          <CustomRadio
            title={dashboard.UpdateNominee.relation}
            name={"relation"}
            selectedValue={formik.values.relation}
            list={props.relations}
            handleRadioChange={(value: string) => {
              resetFieldError("relation");
              props.handleNomineeChange("relation", value, props.index - 1);
            }}
            key={formik.values.relation}
            error={!!formik.errors.relation}
            helperText={formik.errors.relation}
            extraClass={"nominee-relation-radio"}
          />
          <div className="nominee-fields">
            <div className="nominee-fields-single">

              <TextInput
                label="Name"
                variant="outlined"
                value={formik.values.name}
                name={"name"}
                onChange={(e) => {
                  resetFieldError("name");
                  return checkForOnlyAlphabets(e.target.value)
                    ? props.handleNomineeChange(
                      "name",
                      e.target.value,
                      props.index - 1
                    )
                    : null;
                }}
                error={!!formik.errors.name}
                helperText={formik.errors.name}
              />
            </div>
            <div className="nominee-fields-single nominee-fields-share">
              <TextInput
                label="%(share)"
                variant="outlined"
                value={formik.values.share}
                name={"share"}
                onChange={(e) => {
                  resetFieldError("share");
                  return Number(e.target.value) <= 100
                    ? props.handleNomineeChange(
                      "share",
                      e.target.value,
                      props.index - 1
                    )
                    : null;
                }}
                error={!!formik.errors.share}
                helperText={formik.errors.share}
              />
            </div>

            <div className="nominee-fields-single">
              <TextInput
                label="Mobile Number"
                variant="outlined"
                value={formik.values.mobileNumber}
                name="mobileNumber"
                onChange={(e) => {
                  const value = e.target.value;
                  resetFieldError("mobileNumber");
                  props.handleNomineeChange("mobileNumber", value || "", props.index - 1);
                }}
                error={!!formik.errors.mobileNumber}
                helperText={formik.errors.mobileNumber}
              />
            </div>


            <div className="nominee-fields-single">
              <TextInput
                label="Email ID"
                variant="outlined"
                value={formik.values.email}
                name={"email"}
                onChange={(e) => {
                  const value = e.target.value;
                  resetFieldError("email");
                  props.handleNomineeChange("email", value || "", props.index - 1);
                }}
                error={!!formik.errors.email}
                helperText={formik.errors.email}
              />
            </div>
            <div className="nominee-fields-single">
              <div className="nct-select">
                <FormControl variant="filled" error={!!formik.errors.idType}>
                  <Select
                    labelId="portfolio-sortby-label"
                    id="portfolio-sortby"
                    name="idType"
                    value={formik.values.idType}
                    displayEmpty
                    onChange={(e) => {
                      resetFieldError("idType");
                      props.handleNomineeChange("idType", e.target.value, props.index - 1);
                    }}
                    style={
                      !formik.values.idType
                        ? { color: "grey" } // Placeholder style
                        : { color: "rgba(0, 0, 0, 0.87)" }
                    }
                  >
                    {/* Placeholder as the first disabled item */}
                    <MenuItem value="" disabled>
                      ID Type
                    </MenuItem>
                    <MenuItem value="PAN">PAN</MenuItem>
                    <MenuItem value="Aadhar">Aadhaar</MenuItem>
                    <MenuItem value="Driving License">Driving Licence</MenuItem>
                    <MenuItem value="Passport">Passport Number</MenuItem>
                  </Select>

                  <FormHelperText className={formik.errors.idType ? "error" : ""}>
                    {formik.errors.idType}
                  </FormHelperText>
                </FormControl>

              </div>
            </div>
            <div
              className="nominee-fields-single"
              style={{
                display: formik.values.idType === "Aadhar" ? "flex" : "block",
                flexDirection: "column",
              }}
            >
              <TextInput
                label={`${formik.values.idType} Number`}
                variant="outlined"
                value={formik.values.idNumber}
                name={"idNumber"}
                disabled={!formik.values.idType}
                onChange={(e) => {
                  let value = e.target.value;
                  if (formik.values.idType === "Aadhar") {
                    value = value.replace(/\D/g, "").slice(0, 4);
                  } else if (formik.values.idType === "PAN") {
                    value = value.replace(/[^A-Za-z0-9]/g, "").slice(0, 10);
                  } else if (formik.values.idType === "Driving License") {
                    value = value.replace(/[^A-Za-z0-9]/g, "").slice(0, 20);
                  }
                  props.handleNomineeChange(
                    "idNumber",
                    value.toUpperCase(),
                    props.index - 1
                  );
                  resetFieldError("idNumber");
                }}
                error={!!formik.errors.idNumber}
                helperText={formik.errors.idNumber}
              />
              {formik.values.idType === "Aadhar" && (
                <div style={{ fontSize: "12px", color: "gray", marginTop: "4px" }}>
                  Note: Please enter the last four digits of Aadhaar number.
                </div>
              )}
            </div>
            <div className="nominee-fields-single">
              <div className="nominee-fields-single">
                <CheckBoxField
                  onChange={(e) => {
                    props.handleAddressCheck(props.index - 1, e.target.checked);
                  }}
                  name="addressCheck"
                  value={formik.values.addressCheck}
                  label={en.dbCommercial.profileDetails.nominees.addressCheck}
                />
              </div>
            </div>
            <div className="nominee-fields-single d-none d-md-block" />
            <div className="nominee-fields-single">
              <TextInput
                label={dashboard.UpdateNominee.nomineeFields.address1}
                variant="outlined"
                name={"address1"}
                value={formik.values.address1}
                onChange={(e) => {
                  resetFieldError("address1");
                  if (isAlphaNumericAddress(e.target.value)) {
                    props.handleNomineeChange(
                      "address1",
                      e.target.value,
                      props.index - 1
                    );
                  }
                }}
                error={!!formik.errors.address1}
                helperText={formik.errors.address1}
              />
            </div>
            <div className="nominee-fields-single">
              <TextInput
                label={dashboard.UpdateNominee.nomineeFields.address2}
                variant="outlined"
                name={"address2"}
                value={formik.values.address2}
                onChange={(e) => {
                  resetFieldError("address2");
                  if (isAlphaNumericAddress(e.target.value)) {
                    props.handleNomineeChange(
                      "address2",
                      e.target.value,
                      props.index - 1
                    );
                  }
                }}
                error={!!formik.errors.address2}
                helperText={formik.errors.address2}
              />
            </div>
            <div className="nominee-fields-single">
              <TextInput
                label={dashboard.UpdateNominee.nomineeFields.address3}
                variant="outlined"
                name={"address3"}
                value={formik.values.address3}
                onChange={(e) => {
                  resetFieldError("address3");
                  if (isAlphaNumericAddress(e.target.value)) {
                    props.handleNomineeChange(
                      "address3",
                      e.target.value,
                      props.index - 1
                    );
                  }
                }}
                error={!!formik.errors.address3}
                helperText={formik.errors.address3}
              />
            </div>
            <div className="nominee-fields-single">
              <TextInput
                label={dashboard.UpdateNominee.nomineeFields.pin}
                variant="outlined"
                name={"pincode"}
                value={formik.values.pincode}
                onChange={(e) => {
                  resetFieldError("pincode");
                  return (/^\d+$/.test(e.target.value) || !e.target.value) &&
                    e.target.value.length < 7
                    ? props.handleNomineeChange(
                      "pincode",
                      e.target.value,
                      props.index - 1
                    )
                    : null;
                  }}
                error={formik.errors.pincode ? true : false}
                helperText={formik.errors.pincode}
              />
            </div>
            <div className="nominee-fields-single">
              <TextInput
                label={dashboard.UpdateNominee.nomineeFields.city}
                variant="outlined"
                value={formik.values.city}
                name={"city"}
                onChange={(e) => {
                  resetFieldError("city");
                  if (!checkForOnlyAlphabets(e.target.value)) return;
                  props.handleNomineeChange(
                    "city",
                    e.target.value,
                    props.index - 1
                  );
                }}
                error={!!formik.errors.city}
                helperText={formik.errors.city}
              />
            </div>
            <div className="nominee-fields-single">
              <TextInput
                label={dashboard.UpdateNominee.nomineeFields.state}
                variant="outlined"
                value={formik.values.state}
                onChange={(e) => {
                  resetFieldError("state");
                  if (
                    !checkForOnlyAlphabets(e.target.value) ||
                    e.target.value.length > 20
                  )
                    return;
                  props.handleNomineeChange(
                    "state",
                    e.target.value,
                    props.index - 1
                  );
                }}
                name={"state"}
                error={!!formik.errors.state}
                helperText={formik.errors.state}
              />
            </div>
            <div className="nominee-fields-single">
              <div className="nct-select">
                <FormControl variant="filled" error={!!formik.errors.country}>
                  <Select
                    labelId="portfolio-sortby-label"
                    id="portfolio-sortby"
                    name="country"
                    value={formik.values.country || ""}
                    onChange={(e) => {
                      resetFieldError("country");
                      props.handleNomineeChange(
                        "country",
                        e.target.value,
                        props.index - 1
                      );
                    }}
                    displayEmpty
                    renderValue={(selected) =>
                      selected === "" ? <span style={{ color: "grey" }}>Country</span> : selected
                    }
                  >
                    <MenuItem value="" disabled>
                      Country
                    </MenuItem>
                    {props?.countriesList.map((country: { label: string; value: string }) => (
                      <MenuItem key={country.value} value={country.value}>
                        {country.label}
                      </MenuItem>
                    ))}
                  </Select>

                  <FormHelperText
                    className={formik.errors.country ? "error" : ""}
                  >
                    {formik.errors.country}
                  </FormHelperText>
                </FormControl>
              </div>
            </div>
            <div className="nominee-fields-single">
              <div className="nominee-fields-single">
                <DatePickerInput
                  id={"date-picker-dialog"}
                  label={"Date of birth"}
                  value={formik.values.dob}
                  onChange={(date) => {
                    resetFieldError("dob");
                    props.handleNomineeChange("dob", date, props.index - 1);
                    if (
                      thisYear - new Date(formik.values.dob).getFullYear() >=
                      18
                    ) {
                      props.handleNomineeChange(
                        "guardianName",
                        "",
                        props.index - 1
                      );
                    } else {
                      props.handleNomineeChange("inCapacitation", false, props.index - 1);
                      props.handleNomineeChange("inCapacitationAmount", "", props.index - 1);
                      props.handleNomineeChange("inCapacitationAmountorPercentageCheck", "", props.index - 1);
                    }
                  }}
                  minDate={_minDateForCalender()}
                  error={!!formik.errors.dob}
                  helperText={formik.errors.dob}
                />
              </div>
            </div>
          </div>
          {thisYear - new Date(formik.values.dob).getFullYear() < 18 && (
            <div className="nominee-guardian-details">
              <h4>{dashboard.UpdateNominee.guardianDetailsHeading}</h4>
              <div className="nominee-fields">
                <div className="nominee-fields-single">
                  <TextInput
                    label={dashboard.UpdateNominee.name}
                    variant="outlined"
                    name={"guardianName"}
                    value={formik.values.guardianName}
                    onChange={(e) => {
                      resetFieldError("guardianName");
                      return checkForOnlyAlphabets(e.target.value)
                        ? props.handleNomineeChange(
                          "guardianName",
                          e.target.value,
                          props.index - 1
                        )
                        : null;
                    }}
                    error={!!formik.errors.guardianName}
                    helperText={formik.errors.guardianName}
                  />
                </div>

                {/* <div className="nominee-fields-single">
                                    <TextInput
                                        label="Date of Birth"
                                        variant="outlined"
                                        value={formik.values.guardianDob}
                                        name={'guardianDob'}
                                        onChange={(e) => {
                                            resetFieldError("guardianDob");
                                            props.handleNomineeChange(
                                                'guardianDob',
                                                e.target.value,
                                                props.index - 1,
                                                )
                                        }}
                                        type={'date'}
                                        inputProps={{
                                            max: moment(new Date()).format('YYYY-MM-DD'), min: minDateForCalender()
                                        }}
                                        InputLabelProps={{ shrink: true }}
                                        helperText={formik.errors.guardianDob}
                                        error={!!formik.errors.guardianDob}
                                    />
                                </div> */}
                {/* <div className="nominee-fields-single">
                                    <TextInput
                                        label={dashboard.UpdateNominee.nomineeFields.address1}
                                        variant="outlined"
                                        name={'guardianAddress'}
                                        value={formik.values.guardianAddress}
                                        onChange={(e) =>
                                            props.handleNomineeChange(
                                                'guardianAddress',
                                                e.target.value,
                                                props.index - 1,
                                            )
                                        }
                                    />
                                </div> */}
              </div>
            </div>
          )}
          <div className="nominee-fields">

            {(!formik.values.dob || thisYear - new Date(formik.values.dob).getFullYear() > 18) && (
              <div className="nominee-fields-single" style={{ flexDirection: "column" }}>
                <Tooltip
                  title={
                    props.nominees.some((n: any, i: number) => n.inCapacitation && i !== (props.index - 1))
                      ? "Incapacitation has already been selected for another nominee. Please deselect it there to make changes."
                      : ""
                  }
                  arrow
                  placement="top"
                  classes={{ tooltip: classes.customTooltip }}

                >
                  <CheckBoxField
                    onChange={(e) => {
                      props.handleInCapacitation(props.index - 1, e.target.checked);
                    }}
                    name="Incapacitation"
                    value={formik.values.inCapacitation}
                    label={en.dbCommercial.profileDetails.nominees.inCapacitation}
                    disabled={
                      props.nominees.some((n: any, i: number) => n.inCapacitation && i !== (props.index - 1))
                    }
                  />

                </Tooltip>
                <span style={{ fontSize: "0.875rem", color: "#555", marginLeft: "1rem", marginTop: "0.25rem" }}>
                (I hereby authorize this nominee to operate	my account on my behalf, in case of my incapacitation. He / She is authorized to encash my assets up to % of assets in the account / folio or Rs.)
                  </span>
              </div>
            )}
            {((!formik.values.dob || thisYear - new Date(formik.values.dob).getFullYear() > 18) && formik.values.inCapacitation) && (
              <div className="nominee-fields-single">
                <FormControl component="fieldset">
                  <RadioGroup
                    style={{ flexDirection: "row" }}
                    value={formik.values.inCapacitationAmountorPercentageCheck}
                    onChange={(e) => {
                      props.handleNomineeChange(
                        "inCapacitationAmountorPercentageCheck",
                        e.target.value,
                        props.index - 1
                      );
                    }}
                  >
                    <div className="investor-radio-button">
                      <FormControlLabel
                        value="Percentage"
                        control={<Radio className="investor-search-radio" style={{ color: "#007ac8" }} />}
                        label="Percentage"
                      />
                    </div>
                    <div className="investor-radio-button">
                      <FormControlLabel
                        value="Amount"
                        control={<Radio className="investor-search-radio" style={{ color: "#007ac8" }} />}
                        label="Amount"
                      />
                    </div>
                  </RadioGroup>
                </FormControl>
              </div>
            )}
            {((!formik.values.dob || thisYear - new Date(formik.values.dob).getFullYear() > 18) && formik.values.inCapacitation) && (
              <div className="nominee-fields-single">
                <TextInput
                  label={`Enter ${formik.values.inCapacitationAmountorPercentageCheck}`}
                  variant="outlined"
                  type="number"
                  value={formik.values.inCapacitationAmount}
                  onChange={(e) => {
                    const value = e.target.value;
                    resetFieldError("inCapacitationAmount");
                    props.handleNomineeChange("inCapacitationAmount", value || "", props.index - 1);
                  }}
                  error={!!formik.errors.inCapacitationAmount}
                  helperText={formik.errors.inCapacitationAmount}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {/* {props.index < 3 && (
                <div className="add-nominee-btn">
                    <a onClick={props.handleAddNominee}>+ {dashboard.UpdateNominee.addNominee}</a>
                </div>
            )} */}
    </>
  );
}
const AddNominee = ({ initialValues = {}, ...props }: any) => {
  const validate = (values: NOMINEEINFO) => {
    const nomineeNames = props.nominees
      .map((_ele: NOMINEEINFO, ind: number) => {
        if (ind !== props.index - 1) {
          return _ele.name?.trim().toLowerCase();
        }
      })
      .filter((name: string) => name);
    if (["PAN", "Driving License", "Passport"].includes(values.idType)) {
      const currentIdNumber = values.idNumber?.trim().toUpperCase();
      if (values.idType === "PAN" && currentIdNumber === props?.investorData.PAN?.trim().toUpperCase()) {
        return {
          idNumber: "Nominee PAN cannot be same as investor's PAN",
        };
      }
      const nomineeIdNumbers = props.nominees
        .map((_ele: NOMINEEINFO, ind: number) => {
          if (ind !== props.index - 1 && _ele.idType === values.idType) {
            return _ele.idNumber?.trim().toUpperCase();
          }
        })
        .filter((idNumber: string | undefined): idNumber is string => Boolean(idNumber));

      if (nomineeIdNumbers.includes(values.idNumber?.trim().toUpperCase())) {
        return {
          idNumber: `${values.idType} number should be unique among all nominees`,
        };
      }
    }
    if (nomineeNames.includes(values.name?.trim().toLowerCase())) {
      return {
        name: `Nominee name should not be same as other nominee names`,
      };
    } else if (
      values.name?.trim().toLowerCase() ===
      props.investorName?.trim().toLowerCase()
    ) {
      return {
        name: `Nominee name can not be investor name`,
      };
    } else if (values.name?.trim().length > MAX_LENGTH_FOR_NOMINEE_NAME) {
      return {
        name: `Nominee name should be less than ${MAX_LENGTH_FOR_NOMINEE_NAME} characters`,
      };
    }
    // if (values.pan === props.pan) {
    //   return {
    //     pan: `Nominee pan should not be the investor pan`,
    //   };
    // } else if (nomineePans.includes(values.pan?.trim().toLowerCase())) {
    //   return {
    //     pan: `Nominee pan should not be same as other nominee pans`,
    //   };
    // }
    if (nomineeNames.includes(values.name?.trim().toLowerCase())) {
      return {
        name: `Nominee name should not be same as other nominee names`,
      };
    }
    if (values?.address1?.trim().length > MAX_LENGTH_FOR_ADDRESS) {
      return {
        address1: `Address should be less than ${MAX_LENGTH_FOR_ADDRESS} characters`,
      };
    }
    if (values?.address2?.trim().length > MAX_LENGTH_FOR_ADDRESS) {
      return {
        address2: `Address should be less than ${MAX_LENGTH_FOR_ADDRESS} characters`,
      };
    }
    if (values?.address3?.trim().length > MAX_LENGTH_FOR_ADDRESS) {
      return {
        address2: `Address should be less than ${MAX_LENGTH_FOR_ADDRESS} characters`,
      };
    }
    if (!values.share?.toString()) {
      return {
        share: "Share is required",
      };
    } else if (Number(values.share) === 0) {
      return {
        share: "Nominee share should not be 0",
      };
    }
    if (!values.mobileNumber) {
      return {
        mobileNumber: "Mobile number is required",
      };
    } else if (!mobileRegex.test(values.mobileNumber)) {
      return {
        mobileNumber: "Invalid mobile number",
      };
    }

    if (!values.email) {
      return {
        email: "Email ID is required",
      };
    } else if (!emailRegex.test(values.email)) {
      return {
        email: "Invalid email ID",
      };
    }

    if (!values.idType) {
      return {
        idType: "ID Type is required",
      };
    }

    if (!values.idNumber) {
      return {
        idNumber: "ID Number is required",
      };
    } else if (values.idType === "Aadhar" && values.idNumber.length !== 4) {
      return {
        idNumber: "Please enter the last 4 digits of Aadhaar number",
      };
    } else if (values.idType === "PAN" && values.idNumber.length !== 10) {
      return {
        idNumber: "PAN number must be 10 characters",
      };
    } else if (values.idType === "Driving License" && values.idNumber.length > 20) {
      return {
        idNumber: "Driving Licence number must be less than 20 characters",
      };
    }
    else if (values.idType === "Passport" && values.idNumber.length > 22) {
      return {
        idNumber: "Passport Number number must be less than 22 characters",
      };
    }
    if (values.dob) {
      const selectedDate = new Date(values.dob);
      if (selectedDate.getTime() > new Date().getTime()) {
        return {
          dob: "Date of birth should not exceed current date",
        };
      }
      const thisYear = new Date().getFullYear();
      const nomineeDobYear = new Date(formik.values.dob).getFullYear();
      if (thisYear - nomineeDobYear < 18) {
        if (
          values.guardianName?.trim().length > MAX_LENGTH_FOR_GUARDIAN_NAME
        ) {
          return {
            guardianName: `Guardian name should be less than ${MAX_LENGTH_FOR_GUARDIAN_NAME} characters`,
          };
        } else if (
          values.guardianName?.trim().toLowerCase() ===
          values.name?.trim().toLowerCase()
        ) {
          return {
            guardianName: `Nominee name and Guardian name should not be same`,
          };
        }
        // if (
        //   values.guardianPan &&
        //   (values.guardianPan === values.pan ||
        //     values.guardianPan === props.pan)
        // ) {
        //   return {
        //     guardianPan:
        //       values.pan === values.guardianPan
        //         ? `Guardian pan should not same as Nominee pan`
        //         : `Guardian pan should not same as Investor pan`,
        //   };
        // }
      }
    }

    // if (values.guardianDob) {
    //     const selectedDate = new Date(values.guardianDob);
    //     if (new Date().getTime() - selectedDate.getTime() < EIGHTEEN_YEARS_IN_MILLISECONDS) {
    //         return {
    //             guardianDob: 'Guardian of the Nominee should be major',
    //         };
    //     }
    //     if (selectedDate < new Date(minDateForCalender())) {
    //         return {
    //             guardianDob: common.errors.dob.ageLessThanHundred,
    //         };
    //     }
    // }
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: () => {
      props.saveNominee("isEditable", false, props.index - 1);
    },
    onReset: () => {
      props.handleResetForm(props.index - 1);
    },
    validationSchema: validationSchemaNominee,
    validateOnChange: false,
    validate: validate,
  });

  const formFields: Partial<InputType>[] = [
    {
      component: AddNomineeForm,
      extraProps: props,
    },
  ];

  useEffect(() => {
    formik.setValues(initialValues, false);
  }, [initialValues]);

  const FormLoad = useCallback(() => {
    return <Form ui={formFields} formik={formik}></Form>;
  }, [formik]);

  return FormLoad();
};

export default AddNominee;
